import * as React from "react";
import { Stack } from "@mui/material";
import PrintoutTable from "../tables/PrintoutTable";
import PrintoutsFilter from "../filters/PrintoutsFilter";

function Printouts() {
    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <PrintoutsFilter/>
            <PrintoutTable/>
        </Stack>
    )
}

export default Printouts;